import { UserDto } from "@/core/features/users/user.dto";
import posthog from "posthog-js";

const noopIdentifyUser = (_user: UserDto) => {
  if (_user) console.info("Logged");
  return;
};

const noopStartRecording = (_durationMinutes?: number) => {
  console.info(_durationMinutes);
  return;
};

const noopStopRecording = () => {
  return;
};

export function usePostHog() {
  const apiKey = process.env.VUE_APP_POSTHOG_API_KEY;
  const apiHost = process.env.VUE_APP_POSTHOG_HOST || "https://eu.i.posthog.com";

  if (!apiKey) {
    return {
      posthog: null,
      identifyUser: noopIdentifyUser,
      startRecording: noopStartRecording,
      stopRecording: noopStopRecording,
    };
  }

  posthog.init(apiKey, {
    api_host: apiHost,
    person_profiles: "identified_only",
    capture_pageview: false,
    capture_pageleave: true,
    disable_session_recording: true,
    session_recording: {
      recordCrossOriginIframes: false,
      maskAllInputs: false,
      maskInputOptions: {
        password: true,
      },
    },
  });

  const identifyUser = (user: UserDto) => {
    if (!user?.id) return;

    posthog.identify(user.id, {
      email: user.email,
      username: user.username,
      name: user.toString(),
      firstName: user.firstName,
      lastName: user.lastName,
      company: user.company?.name,
      operativeUnit: user.operativeUnit?.name,
      role: user.role?.name,
    });
  };

  const startRecording = (durationMinutes = 5) => {
    const isRecordingEnabled = process.env.VUE_APP_POSTHOG_RECORDING_ENABLED === "true";

    if (!isRecordingEnabled) {
      return;
    }

    posthog.startSessionRecording(true);

    setTimeout(() => {
      posthog.stopSessionRecording();
    }, durationMinutes * 60 * 1000);
  };

  const stopRecording = () => {
    posthog.stopSessionRecording();
  };

  return { posthog, identifyUser, startRecording, stopRecording };
}
